<template>
  <div id="wrapper" v-if="isRender">
    <admin-gnb class="hidden-sm hidden-xs"
               :currentTab="currentTab"
               :menuList="menuList"
               @logout="showLogoutModal()"></admin-gnb>
    <admin-mobile-gnb class="hidden-lg hidden-md"
                      ref="adminMobileGnb"
                      :currentTab="currentTab"
                      :menuList="menuList"
                      @setOverlay="bool => this.activeMobileGnb = bool"
                      @logout="showLogoutModal()"></admin-mobile-gnb>
    <ul class="nav-tab-sub" v-if="hasSubTab">
      <li v-for="tab in subTabList" :key="tab.code">
        <router-link :to="tab.path">{{ tab.name }}</router-link>
      </li>
    </ul>
    <router-view :class="['content', {'has-sub-tab': hasSubTab }]"></router-view>
    <modal ref="logoutModal"
           :id="logoutModal.id"
           :type="logoutModal.type"
           :title="logoutModal.title"
           :size="logoutModal.size"
           :fields="logoutModal.fields"
           @submit="$store.dispatch('logout')"></modal>
    <div v-if="activeMobileGnb" class="sidebar-overlay" @click="$refs.adminMobileGnb.close()"></div>
    <toast-bar></toast-bar>
  </div>
</template>

<script>
  import AdminGnb from '@/components/admin/AdminGnb'
  import AdminMobileGnb from '@/components/admin/AdminMobileGnb'
  import Modal from 'common/components/Modal'
  import ToastBar from 'common/components/ToastMessage'
  import { mapGetters } from 'vuex'

  export default {
    name: 'admin-layout',
    components: {
      AdminGnb,
      AdminMobileGnb,
      Modal,
      ToastBar
    },
    data () {
      return {
        isRender: false,
        activeMobileGnb: false,
        menuList: [
          {
            name: '대시보드',
            path: '/admin/dashboard',
            code: 'DASHBOARDADMIN'
          },
          {
            name: '회원사목록',
            path: '/admin/partner',
            code: 'PARTNERADMIN'
          },
          {
            name: '이용권/쿠폰 관리',
            path: '/admin/coupon/publish',
            code: 'COUPONADMIN',
            children: [
              {
                name: '발행내역',
                path: '/admin/coupon/publish',
                parent_code: 'COUPON',
                code: 'COUPONPUB'
              },
              {
                name: '사용내역',
                path: '/admin/coupon/use',
                parent_code: 'COUPON',
                code: 'COUPONUSE'
              }
            ]
          }
        ],
        logoutModal: {
          id: 'logoutModal',
          type: 'confirm',
          title: '로그아웃',
          size: 'modal-sm',
          fields: [
            {
              type: 'message',
              message: ['로그아웃 하시겠습니까?'],
              class: 'text-center'
            }
          ]
        }
      }
    },
    computed: {
      ...mapGetters({
        user: 'user'
      }),
      currentTab () {
        // 현재 URL에 상위 코드값으로 해당되는 GNB 카테고리를 active 처리한다.
        const route = this.$route
        const meta = route.meta
        const parentCode = meta.hasOwnProperty('parentCode') ? meta.parentCode : ''

        return parentCode
      },
      hasSubTab () {
        return this.subTabList.length > 0
      },
      subTabList () {
        const currentMenu = this.menuList.find(({ code }) => code === this.currentTab)

        return currentMenu.hasOwnProperty('children') ? currentMenu.children : []
      }
    },
    watch: {
      user: {
        handler: 'checkAccessMenu'
      }
    },
    created () {
      const token = localStorage.getItem('_t')

      if (!token) {
        return this.$router.push({name: 'login'})
      }

      // 토큰 유효성 검증 후 해줌 임직원 일 경우에만 화면 렌더
      this.$store.dispatch('inspectToken', token).then(() => {
        if (this.user.id) {
          this.checkAccessMenu()
        }
      })
    },
    methods: {
      checkAccessMenu () {
        if (this.user.auth_level === '90') {
          this.isRender = true
        } else {
          return this.$router.go(-1)
        }
      },
      showLogoutModal () {
        this.$refs.logoutModal.show()
      }
    }
  }
</script>

<style lang="scss" scoped>
  #wrapper {
    height: 100%;
  }

  .nav-tab-sub {
    position: fixed;
    top: 64px;
    height: 48px;
    width: 100%;
    padding: 0 24px;
    margin: 0;
    background-color: $hzc-white;
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.1);
    list-style: none;
    z-index: 3;

    li {
      display: inline-block;
    }

    a {
      display: block;
      padding: 14px 8px 11px;
      margin: 0 24px 0 0;
      font-size: 14px;
      font-weight: bold;
      line-height: 1.43;
      letter-spacing: -0.35px;
      text-align: center;
      text-decoration: none;
      color: $font-color;

      &:hover,
      &.active {
        border-bottom: 3px solid $font-color;
      }
    }
  }

  .content {
    height: 100%;
    padding: 64px 0 0;

    &.has-sub-tab {
      padding: 112px 0 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/layouts/Admin.vue